// ═══════════════════════════════════════════════════════════════
// Field Rules Engine — Shared Types
// Used by: API (CRUD, execution), Web Worker, Admin UI
// ═══════════════════════════════════════════════════════════════
/** Type guard: is this a ConditionGroup (vs SingleCondition)? */
export function isConditionGroup(c) {
    return "logic" in c;
}
// --- Helper ---
export function getActionTier(type) {
    const serverTypes = [
        "uniqueness", "historicalRange", "lookup",
        "webhook_validate", "webhook_transform", "expression",
    ];
    return serverTypes.includes(type) ? "server" : "client";
}
//# sourceMappingURL=rules.js.map